module.exports = __webpack_public_path__ + "static/img/marmalade_pictgrid14_800x800.754d8a0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/marmalade_pictgrid14_800x800.jpg
// module id = C2q7
// module chunks = 0